<template>
  <section v-if="!vm.isMobile" class="hight-efficency-connection">
    <div class="connection">
      <transition :name="transitionClassName" :duration="400">
        <div v-if="showType === 0" :key="0" class="content content-tv">
          <div :class="['img-wrap', { 'tv-in': showTvAni, 'tv-in-plyaed': showTvAni === 'played' }]">
            <div class="img1">
              <video
                class="connection-video-tv"
                src="../../assets/zh/highEfficiency/connection-tv.mp4"
                autoplay
                loop
                muted="muted"
                preload="metadata"
              ></video>
              <img v-lazy="require('../../assets/zh/highEfficiency/tv-pc-bg.png')" class="connection-tv-pic" alt />
            </div>
            <!-- <div ref="tvPhone" class="phone-placeholder"></div> -->
            <div class="connection-phone img2">
              <lazy-component>
                <video
                  src="../../assets/zh/highEfficiency/connection-phone.mp4"
                  autoplay
                  loop
                  muted="muted"
                  preload="metadata"
                ></video>
              </lazy-component>
              <img
                ref="connectionPhone"
                v-lazy="require('../../assets/zh/highEfficiency/tv-phone.png')"
                class="connection-tv-phone"
                :style="phoneStyles"
                alt
              />
            </div>
          </div>
          <div v-textMotion="10" class="text-wrap">
            <div class="title">电视互联</div>
            <div class="sub-title">想投的，不想投的，尽在掌握</div>
            <div class="description">
              投屏内容可以缩至小窗，而不影响手机的其他操作，收到的微信消息、来电通知等隐私信息也不会显示在大屏。此外，使用相同HeyTap账号登陆手机和电视，还可在大屏上欣赏云相册中的共享照片，即使熄灭手机屏幕，投屏内容也不会中断。
            </div>
          </div>
        </div>
        <div v-if="showType === 1" :key="1" class="content content-watch">
          <div class="img-wrap">
            <div ref="watchPhone" class="phone-placehoder">
              <img v-lazy="require('../../assets/zh/highEfficiency/watch-h5.png')" class="img1" alt />
            </div>
            <img v-lazy="require('../../assets/zh/highEfficiency/watch.png')" class="watch img2" alt />
          </div>
          <div class="text-wrap">
            <div class="title">手表互联</div>
            <div class="sub-title">健康，得心应手</div>
            <div class="description">
              戴上手表，就能体验入睡到起床的完整睡眠检测；此外，通过Breeno指令一键开启运动，还能触发手表运动助手，辅助你更安全有效地进行体能跑步、户外健走等锻炼。
            </div>
          </div>
        </div>
        <div v-if="showType === 2" :key="2" class="content content-wristband">
          <div class="img-wrap">
            <div ref="wristbandPhone" class="phone-placehoder">
              <img v-lazy="require('../../assets/zh/highEfficiency/wristband-h5.png')" class="img1" alt />
            </div>
            <img v-lazy="require('../../assets/zh/highEfficiency/wristband.png')" class="wristband img2" alt />
          </div>
          <div class="text-wrap">
            <div class="title">手环互联</div>
            <div class="sub-title">便捷应答，手机放一边</div>
            <div class="description">
              支持微信消息推送、短信提醒、来电通知和查找手机等功能，不用拿出手机就能快速响应。
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
  <section v-else class="hight-efficency-connection-h5">
    <swiper :options="swiperOptions">
      <swiper-slide>
        <div class="img-wrap img-wrap-tv wow textMotion" data-wow-duration="0.4s">
          <img src="../../assets/zh/highEfficiency/tv.jpg" class="tv" alt />
          <img src="../../assets/zh/highEfficiency/tv-h5.png" class="tv-h5" alt />
        </div>
        <div v-textMotion="offsetH5" class="text-wrap text-wrap-tv">
          <div class="title">电视互联</div>
          <div class="sub-title">
            想投的，不想投的，
            <br />尽在掌握
          </div>
          <div class="description">
            投屏内容可以缩至小窗，而不影响手机的其他操作，收到的微信消息、来电通知等隐私信息也不会显示在大屏。此外，使用相同HeyTap账号登陆手机和电视，还可在大屏上欣赏云相册中的共享照片，即使熄灭手机屏幕，投屏内容也不会中断。
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div :class="['img-wrap', { 'img-wrap-ani': showAni1 }]">
          <img src="../../assets/zh/highEfficiency/watch-h5.png" class="phone" alt />
          <img src="../../assets/zh/highEfficiency/watch.png" class="watch" alt />
        </div>
        <div :class="['text-wrap', { 'text-wrap-ani': showAni1 }]">
          <div class="title">手表互联</div>
          <div class="sub-title">
            健康，
            <br />得心应手
          </div>
          <div class="description">
            戴上手表，就能体验入睡到起床的完整睡眠检测；此外，通过Breeno指令一键开启运动，还能触发手表运动助手，辅助你更安全有效地进行体能跑步、户外健走等锻炼。
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div :class="['img-wrap', { 'img-wrap-ani': showAni2 }]">
          <img src="../../assets/zh/highEfficiency/wristband-h5.png" class="phone" alt />
          <img src="../../assets/zh/highEfficiency/wristband.png" class="wristband" alt />
        </div>
        <div :class="['text-wrap', { 'text-wrap-ani': showAni2 }]">
          <div class="title">手环互联</div>
          <div class="sub-title">
            便捷应答，
            <br />手机放一边
          </div>
          <div class="description">
            支持微信消息推送、短信提醒、来电通知和查找手机等功能，不用拿出手机就能快速响应。
          </div>
        </div>
      </swiper-slide>
      <div
        slot="pagination"
        class="swiper-pagination wow textMotion"
        data-wow-duration="0.4s"
        :data-wow-offset="offsetH5"
      ></div>
    </swiper>
  </section>
</template>

<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
export default {
  inject: ['vm'],
  data() {
    let self = this;
    return {
      phoneWidth: 282,
      phoneHeight: 128,
      phoneTranslateX: 0,
      phoneTranslateY: 0,
      showType: 0,
      offsetH5: screen.availHeight / 2 - 360,
      activeIndex: 0,
      transitionClassName: 'fade-connection-forward',
      showAni1: false,
      showAni2: false,
      showTvAni: false,
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          bulletActiveClass: 'actived',
          bulletElement: 'div',
          bulletClass: 'pagination'
        },
        on: {
          transitionStart: function() {
            self['showAni' + this.activeIndex] = true;
          }
        }
      }
    };
  },
  computed: {
    phoneStyles() {
      let width = this.phoneWidth + 'px';
      let height = this.phoneHeight + 'px';
      let translateX = this.phoneTranslateX + 'px';
      let translateY = this.phoneTranslateY + 'px';
      return {
        width,
        height,
        transform: `translate(${translateX},${translateY})`
      };
    }
  },
  mounted() {
    if (!this.vm.isMobile) this.initScene();
  },
  methods: {
    initScene() {
      this.connectionWrapDom = document.querySelector('.hight-efficency-connection');
      this.duration = document.querySelector('.connection').clientWidth * 2 + 20;
      this.scene = new ScrollMagic.Scene({
        duration: window.innerWidth * 3,
        triggerElement: '.hight-efficency-connection',
        triggerHook: 0
      })
        .setPin('.hight-efficency-connection')
        .addTo(Controller);

      // scene.on('progress', event => {
      //   this.handleScrollHorizen(event);
      // });
      const debounceScroll = this.debounce(this.handleAni, 65);
      this.scene.on('progress', event => {
        this.isPlayedChanging && debounceScroll(event);
        this.isPlayedChanging = true;
      });
      this.scene.on('enter', () => {
        this.isPlayedChanging = false;
        this.scene.duration(window.innerWidth * 3);
      });
      let scene2 = new ScrollMagic.Scene({
        duration: 300,
        triggerElement: '.hight-efficency-connection',
        triggerHook: 0.4
      }).addTo(Controller);

      scene2.on('start', () => {
        this.showTvAni = true;
        setTimeout(() => {
          this.showTvAni = 'played';
        }, 350);
      });
    },
    handleScrollHorizen(e) {
      let { progress } = e;
      this.connectionWrapDom.scrollLeft = this.duration * progress;
    },
    handleAni(event) {
      // 如果动画正在播放则直接返回
      if (this.isAnimating) return;
      this.isAnimating = true;
      let { scrollDirection } = event;
      if (scrollDirection === 'PAUSED') return;
      this.transitionClassName = scrollDirection === 'FORWARD' ? 'fade-connection-forward' : 'fade-connection-reverse';
      if (this.showType === 2 && scrollDirection === 'FORWARD') {
        console.log(this.scene.scrollOffset(), window.pageYOffset);
        this.scene.duration(window.pageYOffset - this.scene.scrollOffset());
      } else if (this.showType === 0 && scrollDirection === 'REVERSE') {
        this.scene.controller().scrollTo(this.scene.scrollOffset());
      } else {
        scrollDirection === 'FORWARD' ? this.showType < 2 && this.showType++ : this.showType > 0 && this.showType--;
      }
      let t = setTimeout(() => {
        clearTimeout(t);
        this.isAnimating = false;
      }, 400);
    },
    debounce(fun, delay) {
      return args => {
        clearTimeout(fun.id);
        fun.id = setTimeout(() => {
          fun.call(this, args);
        }, delay);
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.hight-efficency-connection {
  display: flex;
  // width: 300vw;
  height: 100vh;
  overflow: hidden;
  flex-wrap: nowrap;
  .connection {
    display: flex;
    flex-shrink: 0;
    width: 100vw;
    height: 100%;
    position: relative;
    .content {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      // .img-wrap{
      //   video,img{
      //     opacity: 0;
      //   }
      // }
    }
  }
  .connection-flex {
    text-align: center;
    justify-content: center;
    align-items: center;
  }
  .phone-placehoder {
    display: inline-block;
    width: 360px;
    height: 790px;
  }
  .text-wrap {
    text-align: center;
    margin: 70px auto 0;
    width: 584px;
  }
  .content-tv {
    bottom: 110px;
    .img-wrap {
      position: relative;
      width: 1124px;
      height: 659px;
      opacity: 0;
      .connection-tv-pic {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 659px;
        z-index: 5;
      }
      .connection-video-tv {
        width: 1120px;
        height: 596px;
        // margin-left: 8px;
        object-fit: cover;
      }
      .connection-tv-phone {
        width: 282px;
        height: 128px;
        transform: translate(0px, 0px);
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
      }
      .tv {
        width: 100%;
      }

      .phone-placeholder {
        position: absolute;
        width: 155px;
        height: 340px;
        bottom: 0;
        right: -25px;
      }
      .connection-phone {
        position: absolute;
        width: 282px;
        height: 128px;
        bottom: 0;
        z-index: 5;
        right: -78px;
        video {
          width: 275px;
          height: 128px;
          border-radius: 17px;
          margin-left: 2px;
        }
      }
    }
    .text-wrap {
      width: 706px;
      text-align: center;
      // margin: 90px auto 0;
      margin: 70px auto 0;
      .description {
        margin: 0 auto;
      }
    }
  }
  .content-watch {
    // bottom: 10.83vh;
    bottom: 136px;
    .img-wrap {
      position: relative;
      width: 360px;
      margin: 0 auto;
      .phone-placehoder {
        position: absolute;
        left: 0;
        bottom: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .watch {
        position: absolute;
        width: 190px;
        bottom: 0px;
        right: -94px;
      }
    }
  }
  .content-wristband {
    // bottom: 13.75vh;
    bottom: 160px;
    .img-wrap {
      position: relative;
      width: 360px;
      margin: 0 auto;
      .phone-placehoder {
        // position: absolute;
        // left: 0;
        // bottom: 15px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .wristband {
        width: 105px;
        height: 290px;
        position: absolute;
        bottom: 0px;
        right: -53px;
      }
    }
    .description {
      margin: 0 auto;
    }
  }
}

@media only screen and (max-height: 800px) {
  .hight-efficency-connection {
    .content-tv {
      bottom: 3.5vh;
    }
    .content-watch {
      bottom: 6.9vh;
    }

    .content-wristband {
      bottom: 10.4vh;
    }
  }
}
@media only screen and (min-height: 1080px) {
  .hight-efficency-connection {
    .content-tv {
      bottom: 132px;
    }

    .content-watch {
      bottom: 158px;
    }

    .content-wristband {
      bottom: 184px;
    }
  }
}
@media only screen and (min-width: 1950px) {
  .hight-efficency-connection {
    .content-tv {
      .img-wrap {
        width: 1148px;
        height: 724px;
        .connection-tv-pic {
          height: 724px;
        }
        .connection-video-tv {
          width: 1145px;
          height: 648px;
        }
      }
    }
  }
}
@media only screen and (max-width: 1440px) {
  .hight-efficency-connection {
    .content-tv {
      .img-wrap {
        width: 899.2px;
        height: 527px;
        .connection-tv-pic {
          height: 527px;
        }
        .connection-video-tv {
          width: 895px;
          height: 478px;
        }
      }
      .text-wrap {
        margin: 53px auto 0;
      }
    }
    .text-wrap {
      margin: 48px auto 0;
      width: 584px;
    }
  }
}
.hight-efficency-connection-h5 {
  height: 720px;
  ::v-deep.swiper-container {
    width: 100%;
    height: 100%;
  }
  ::v-deep.swiper-slide {
    overflow: hidden;
  }
  ::v-deep.swiper-pagination {
    width: 136px;
    top: 415px;
    left: 20px;
    display: flex;
    .pagination {
      width: 40px;
      height: 2px;
      background: rgba($color: #000000, $alpha: 0.2);
      border-radius: 26px;
      display: inline-block;
      transition: background 0.3s linear;
    }
    .pagination ~ .pagination {
      margin-left: 8px;
    }
    .actived {
      background: #000;
      transition: background 0.3s linear;
    }
  }
  .img-wrap {
    height: 360px;
    margin-top: 25px;
    margin-left: 20px;
    position: relative;
    img {
      opacity: 0;
    }
    .tv {
      width: 332px;
      opacity: 1;
    }
    .tv-h5 {
      opacity: 1;
      position: absolute;
      width: 142px;
      height: 65px;
      bottom: 0;
      left: 17px;
    }
    .phone {
      height: 360px;
    }
    .watch {
      position: absolute;
      bottom: 0;
      left: 128px;
      width: 125px;
      height: 191px;
    }
    .wristband {
      position: absolute;
      bottom: 0;
      left: 127px;
      width: 81px;
      height: 224px;
    }
  }
  .img-wrap-tv {
    height: auto;
    margin-left: 0px;

    text-align: right;
  }
  .text-wrap {
    padding-top: 62px;
    padding-left: 20px;
    * {
      opacity: 0;
    }
    .description {
      width: 335px;
    }
  }
  .text-wrap-tv * {
    opacity: 1;
  }
  .img-wrap-ani {
    img:nth-child(1) {
      animation: fadeInLeft 0.3s cubic-bezier(0, 0, 0.1, 1) forwards;
    }
    img:nth-child(2) {
      animation: fadeInLeft 0.2s 0.2s cubic-bezier(0, 0, 0.1, 1) forwards;
    }
  }
  .text-wrap-ani {
    .title {
      animation: textMotion 0.4s 0.3s cubic-bezier(0, 0, 0.1, 1) forwards;
    }
    .sub-title {
      animation: textMotion 0.4s 0.8s cubic-bezier(0, 0, 0.1, 1) forwards;
    }
    .description {
      animation: textMotion 0.4s 1s cubic-bezier(0, 0, 0.1, 1) forwards;
    }
  }
}
.tv-in {
  animation: textMotion 0.4s cubic-bezier(0, 0, 0.1, 1) forwards;
  .connection-phone {
    animation: textMotion 0.4s 0.3s cubic-bezier(0, 0, 0.1, 1) forwards;
  }
}
.tv-in-plyaed {
  opacity: 1 !important;
  animation: none;
  .connection-phone {
    animation: none;
  }
}
@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translateX(60px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
.fade-connection-forward-leave-active,
.fade-connection-reverse-leave-active {
  animation: fadeOut 0.3s linear forwards;
}
.fade-connection-reverse-enter {
  .img-wrap {
    .img1,
    .img2 {
      opacity: 0;
      transform: translateX(-60px);
    }
  }
}
.fade-connection-forward-enter {
  .img-wrap {
    .img1,
    .img2 {
      opacity: 0;
      transform: translateX(60px);
    }
  }
}
.fade-connection-forward-enter-to,
.fade-connection-reverse-enter-to {
  .img-wrap {
    .img1,
    .img2 {
      opacity: 1;
      transform: translateX(0);
    }
  }
}
.fade-connection-forward-enter-active,
.fade-connection-reverse-enter-active {
  .img-wrap {
    .img1 {
      transition: all 0.3s cubic-bezier(0, 0, 0.1, 1);
    }
    .img2 {
      transition: all 0.2s 0.2s cubic-bezier(0, 0, 0.1, 1);
    }
  }
  .text-wrap {
    animation: fadeIn 0.3s linear forwards;
  }
}
</style>
